import React from 'react';
import EmptyTopNav from 'components/topNav/EmptyTopNav';
import { useStores } from 'common/hooks/useStores';
import { observer } from 'mobx-react';

const Unauthorized = () => {
    const { authStore } = useStores();

    function logout() {
        authStore.logout();
    }

    return (
        <div className="u-padding-lg-left u-padding-lg-top">
            <EmptyTopNav />

            <h1>Your account is not authorized to access this instance.</h1>

            <div className={'u-margin-bottom'}>Please contact your administrator or support to be added</div>

            <button className="c-button c-button--primary" onClick={() => logout()}>
                Logout
            </button>
        </div>
    );
};

export default observer(Unauthorized);
